import { queryOptions } from '@tanstack/react-query';
import { Domain, } from '@repo/domain';
import { resolveRepository } from '../registry/resolveRepository';
export const billingKeys = {
    all: ['billing'],
    get: (filter, scope) => ['billing', filter, scope],
};
export const billingOptions = {
    get: (filter, scope) => queryOptions({
        queryKey: billingKeys.get(filter, scope),
        queryFn: async () => {
            const repo = await resolveRepository(Domain.Billing);
            return repo.get(filter, scope);
        },
    }),
    create: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.Billing);
            return repo.create(request);
        },
    }),
    update: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.Billing);
            return repo.update(request);
        },
    }),
    remove: () => ({
        mutationFn: async (id) => {
            const repo = await resolveRepository(Domain.Billing);
            return repo.remove(id);
        },
    }),
    selectDefault: () => ({
        mutationFn: async (id) => {
            const repo = await resolveRepository(Domain.Billing);
            return repo.selectDefault(id);
        },
    }),
};
